import { useState, useEffect } from 'react';
import { FlowNode } from '../../types';

interface Props {
  node: FlowNode;
  onUpdate: (updated: FlowNode) => void;
}

export function TokenLookupStepConfig({ node, onUpdate }: Props) {
  const [customerId, setCustomerId] = useState((node.config?.customerId as string) ?? '');
  const [tool, setTool] = useState((node.config?.tool as string) ?? '');
  const [alias, setAlias] = useState<string>((node.config?.alias as string) ?? '');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setCustomerId((node.config?.customerId as string) ?? '');
    setTool((node.config?.tool as string) ?? '');
    setAlias((node.config?.alias as string) ?? '');
  }, [node.id]);

  useEffect(() => {
    const next = {
      ...node.config,
      customerId,
      tool,
      ...(alias.trim() ? { alias: alias.trim() } : {}),
    };
    if (!alias.trim()) delete (next as Record<string, unknown>).alias;
    if (JSON.stringify(next) === JSON.stringify(node.config ?? {})) return;
    const t = setTimeout(() => onUpdate({ ...node, config: next }), 150);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, tool, alias]);

  return (
    <div className="space-y-3">
      <div>
        <label className="text-xs text-muted-foreground block mb-1">
          Customer ID
        </label>
        <input
          type="text"
          className="w-full border border-input rounded p-1.5 text-xs font-mono bg-background"
          placeholder="{{body.customerId}}"
          value={customerId}
          onChange={e => setCustomerId(e.target.value)}
        />
      </div>
      <div>
        <label className="text-xs text-muted-foreground block mb-1">
          Tool (slug)
        </label>
        <input
          type="text"
          className="w-full border border-input rounded p-1.5 text-xs font-mono bg-background"
          placeholder="asana"
          value={tool}
          onChange={e => setTool(e.target.value)}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        Fetches a stored OAuth token. Use <span className="font-mono">{'{{nodeId.accessToken}}'}</span> or{' '}
        <span className="font-mono">{'{{nodeId.metadata}}'}</span> in later steps.
      </p>
      <div className="flex flex-col gap-1">
        <label className="text-xs text-muted-foreground font-medium">Step alias</label>
        <input
          type="text"
          className="border border-input rounded p-1.5 text-xs font-mono bg-background"
          placeholder="e.g. get-token"
          value={alias}
          onChange={e => setAlias(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
        />
        {alias && (
          <p className="text-xs text-muted-foreground">
            Reference as{' '}
            <span className="font-mono text-primary">{`{{${alias}.accessToken}}`}</span>
          </p>
        )}
      </div>
    </div>
  );
}
